import type { Client, ClientContact } from '@/types'

export const MAX_CONTACTS = 20

export function isBusinessClientType(
  type: string | null | undefined
): boolean {
  return type === 'company' || type === 'property_management'
}

export function maxContactsForType(_type?: string | null): number {
  return MAX_CONTACTS
}

export function primaryContact(
  client?: Pick<Client, 'contacts'> | null
): ClientContact | undefined {
  if (!client?.contacts?.length) return undefined
  return [...client.contacts].sort((a, b) => a.sort_order - b.sort_order)[0]
}

export function primaryEmail(
  client?: (Pick<Client, 'contacts'> & { email?: string | null }) | null
): string | undefined {
  return primaryContact(client)?.email?.trim() || client?.email?.trim() || undefined
}

export function primaryPhone(
  client?: (Pick<Client, 'contacts'> & { phone?: string | null }) | null
): string | undefined {
  return primaryContact(client)?.phone?.trim() || client?.phone?.trim() || undefined
}

export function contactDisplayName(
  contact: Pick<ClientContact, 'full_name'>,
  fallback: string
): string {
  return contact.full_name?.trim() || fallback
}
